import { observable, action } from 'mobx';
import RootStore, { useRootStore } from './index';
import { MeQuery_me } from 'api';
import { KMSAccessToken } from 'services/Authentication';

export class User {
  _rootStore: RootStore;
  @observable user: MeQuery_me | null = null;
  @observable isAuthenticated = Boolean(localStorage.getItem(KMSAccessToken));
  @observable adBlockerOn = false;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
  }

  @action initializeUser(me: MeQuery_me): void {
    this.user = me;
  }

  @action authenticate(): void {
    this.isAuthenticated = true;
  }
}

export const useUser = () => {
  const store = useRootStore();
  if (!store.user) throw new Error('User has not been initialized');
  return store.user;
};
